// @ts-nocheck
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const Kandidatura = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);
  return (
    <>
      <div className="container max-w-screen-lg pt-3 pb-3 ">
        <h1 className="py-3 text-3xl md:text-5xl font-bold text-[#A81414] ">Кандидатура</h1>
        <div className="text-justify hyphens-auto" id="section3">
          <div className="pt-3 pb-3">
            Особі, яка має намір стати салезіянином, створюються відповідні умови та середовище, щоб вона могла пізнати своє покликання, зростати як людина і як християнин. Під духовним проводом кандидат поступово приходить до усвідомленого вибору, вільного від будь-якого внутрішнього чи зовнішнього тиску.
          </div>
          <div className="pt-3 pb-3">
            Кандидатура є першим етапом ознайомлення з богопосвяченим життям і початком формації у Згромадженні, який безпосередньо готує до новіціату. Її мета — духовне пробудження, пошук і розвиток покликання. Протягом шести місяців кандидати знайомляться з духовністю та місією Згромадження, а настоятелі оцінюють їхню готовність до служіння у салезіянській спільноті.
          </div>
          <div className="pt-3 pb-3">
            Кандидатура проходить у формаційній спільноті у Вальдокко (Італія). Життя в спільноті є невід’ємною частиною салезіянського покликання: воно вимагає подолання індивідуалізму, відповідної людської та християнської зрілості, відкритості до служіння. Перед вступом до новіціату кандидати вчаться співжити з іншими, переживають радості та труднощі спільнотного життя, щоб розпізнати, чи справді це шлях, до якого кличе їх Христос.
          </div>
          <div className="pt-3 pb-3 pt-3 pb-3 font-semibold text-[#A81414]">
            Ознаки справжнього покликання:
          </div>
          <ul className="pl-6 list-disc">
            <li className="pt-1 pb-1">щире й мотивоване бажання служити Богові у Згромадженні;


            </li>
            <li className="pt-1 pb-1">свобода у прийнятті рішення;


            </li>
            <li className="pt-1 pb-1">здатність до життя у спільноті та готовність до служіння;


            </li>
            <li className="pt-1 pb-1">відкритість до праці серед молоді, особливо маргіналізованої;


            </li>
            <li className="pt-1 pb-1">фізичне і психічне здоров’я, інтелектуальна зрілість;


            </li>
            <li className="pt-1 pb-1">духовна та моральна стійкість;


            </li>
            <li className="pt-1 pb-1">відсутність перешкод, визначених церковним правом.


            </li>
          </ul>
          <div className="pt-3 pb-3 pt-3 pb-3 font-semibold text-[#A81414]">
            Необхідними умовами для прийняття в кандидатуру є також:
          </div>
          <ul className="pl-6 list-disc">
            <li className="pt-1 pb-1">
              середня освіта;
            </li>
            <li className="pt-1 pb-1">
              практикування християнського життя.
            </li>
          </ul>
          <div className="pt-3 pb-3">
            Психічна зрілість кандидата виявляється у сталій духовній поставі, здатності жити в целібаті, відданому Богові, приймати послух і вбогість, а також у відповідальному ставленні до людей і прийнятті важливих рішень.
          </div>
          <div className="pt-3 pb-3">
            Кандидати вчаться шукати Христа — Доброго Пастиря — у молитві, розважанні над Євангелієм, наслідуючи Його в любові та простоті. Особливий акцент робиться на чеснотах, властивих апостольській спільноті: братній любові, самовідреченні, довірі, щирості серця, великодушності, лагідності, радості у випробуваннях і готовності служити всім.
          </div>

          <div className="pt-3 pb-3 pt-3 pb-3 font-semibold text-[#A81414]">
            Документи, необхідні для вступу:
          </div>
          <ul className="pl-6 list-disc">
            <li className="pt-1 pb-1">пписьмове прохання про прийняття;
            </li>
            <li className="pt-1 pb-1">свідоцтва про хрещення та миропомазання;
            </li>
            <li className="pt-1 pb-1">рекомендаційний лист пароха;
            </li>
            <li className="pt-1 pb-1">документи про освіту;
            </li>
            <li className="pt-1 pb-1">свідоцтво про народження;
            </li>
            <li className="pt-1 pb-1">автобіографія з описом покликання;
            </li>
            <li className="pt-1 pb-1">копію паспорта і податковий номер;
            </li>
            <li className="pt-1 pb-1">військовий квиток або приписне свідоцтво;
            </li>
            <li className="pt-1 pb-1">медична довідка про стан здоровʼя;
            </li>
            <li className="pt-1 pb-1">сертифікати ЗНО (за наявності).
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Kandidatura;
